module.exports = __webpack_public_path__ + "img/3.bbef916.svg";